// Конфигурация скиммеров
// Централизованное хранилище всех настроек, путей к моделям и коэффициентов

export const SKIMMER_CONFIG = {
    /** Лимит инстансов после батча всех строк (производительность). Обрезка — пропорционально по сторонам. */
    MAX_INSTANCES: 120,

    // Размеры скиммеров - разные размеры для разных моделей
    SCALES: {
        EM0010: [0.2, 0.2, 0.2],
        EM0020: [0.2, 0.2, 0.2],
        EM0030: [0.25, 0.25, 0.22],
        EM0050: [0.25, 0.25, 0.22],
        EM0130: [0.16, 0.16, 0.16],
        EM0140: [0.25, 0.25, 0.2],
        EM0180: [0.27, 0.27, 0.19],
        DEFAULT: [0.25, 0.25, 0.25]
    },

    // Пути к моделям
    MODELS: {
        EM0010: '/models/skimmers/skimmer10.glb',
        EM0020: '/models/skimmers/skimmer10.glb',
        EM0030: '/models/skimmers/skimmer50.glb',
        EM0050: '/models/skimmers/skimmer50.glb',
        EM0130: '/models/skimmers/skimmer130.glb',
        EM0140: '/models/skimmers/skimmer140.glb',
        EM0180: '/models/skimmers/skimmer180.glb',
        DEFAULT: '/models/skimmers/skimmer10.glb'
    },

    // Базовые высоты установки (от верха бассейна)
    BASE_HEIGHTS: {
        EM0010: 0.09,
        EM0020: 0.09,
        EM0030: 0.105,
        EM0050: 0.105,
        EM0130: 0.085,
        EM0140: 0.075,
        EM0180: 0.062,
        DEFAULT: 0.09
    },

    // Отступы от стены (смещение вглубь/наружу)
    WALL_OFFSETS: {
        EM0010: -0.01,
        EM0020: -0.01,
        EM0030: -0.01,
        EM0050: -0.01,
        EM0130: -0.011,
        EM0140: -0.012,
        EM0180: -0.014,
        DEFAULT: 0
    },

    // Повороты моделей
    ROTATIONS: {
        EM0010: [0, Math.PI + Math.PI + Math.PI, 0],
        EM0020: [0, Math.PI + Math.PI + Math.PI, 0],
        DEFAULT: [0, Math.PI, 0]
    },

    // Константы для логики позиционирования
    POSITIONING: {
        BASE_WIDTH: 4,
        BASE_DEPTH: 1.5,
        BASE_LENGTH: 4,
        MIN_OFFSET: 0.1,
        // Дополнительное опускание скиммера от верхней кромки (в мировых единицах)
        TOP_EDGE_EXTRA_DROP: 0.035,

        // Коэффициенты масштабирования
        MIN_DEPTH_SCALE: 0.65,
        MIN_LENGTH_SCALE: 0.65,
        MIN_WIDTH_SCALE: 0.65,
        MIN_Z_SCALE: 0.1,
        PROJ_SCALE_MIN: 0.6,

        // Коэффициенты компенсации при уменьшении модели
        // По высоте: чем больше, тем сильнее поднимаем скиммер к борту при уменьшении.
        HEIGHT_COMPENSATION_FACTOR: 1.0,
        // По вылету: чем больше, тем сильнее выдвигаем скиммер внутрь чаши при уменьшении.
        WALL_PROTRUSION_COMPENSATION_MAX: -0.004,
    }
};
